import { useEffect, useState } from "react";
import { RouterProvider } from "react-router";
import { FavoritesProvider } from "./contexts/FavoritesContext";
import { AuthProvider } from "./contexts/AuthContext";
import { AppToaster, ConfirmDialogHost, LikeHeartOverlay, PaymentHandoffHost } from "./components/ui";
import { PushPermissionPrompt } from "./components/shared/PushPermissionPrompt";
import { CapacitorDeepLinkHandler } from "./CapacitorDeepLinkHandler";
import { router } from "./routing";
import { isPushSupported } from "./services/pushService";

// React Native app is in /react-native-app folder

/** VAPID public key for Web Push — set via VITE_VAPID_PUBLIC_KEY env var.
 *  In production, this is set at build time. Never hardcode the private key here. */
const VAPID_PUBLIC_KEY = (import.meta.env.VITE_VAPID_PUBLIC_KEY as string) || "";

export default function App() {
  const [swReady, setSwReady] = useState(false);

  // Register Service Worker for PWA functionality
  useEffect(() => {
    // Prevent pull-to-refresh on mobile
    document.body.style.overscrollBehavior = "none";

    const registerSW = async () => {
      if (
        "serviceWorker" in navigator &&
        globalThis.isSecureContext
      ) {
        try {
          await navigator.serviceWorker.register("/service-worker.js");
          console.log("ServiceWorker registered");
          setSwReady(true);
        } catch (err) {
          console.log("ServiceWorker failed:", err);
        }
      }
    };

    registerSW();
  }, []);

  return (
    <AuthProvider>
      <FavoritesProvider>
        {/* Needs useAuth (AuthProvider) to refresh entitlements, and the router to
            navigate — see CapacitorDeepLinkHandler.tsx for why this exists. */}
        <CapacitorDeepLinkHandler />
        <RouterProvider router={router} />
        <ConfirmDialogHost />
        <PaymentHandoffHost />
        <AppToaster />
        <LikeHeartOverlay />

        {/* Push notification permission prompt — shown after SW is ready and user is logged in */}
        {swReady && VAPID_PUBLIC_KEY && isPushSupported() && (
          <PushPermissionPrompt vapidPublicKey={VAPID_PUBLIC_KEY} />
        )}
      </FavoritesProvider>
    </AuthProvider>
  );
}